import { useState } from 'react';
import PropTypes from 'prop-types';

import Layout, { LayoutTemplates } from '../../layouts/layouts';
import useOutClick from '../../hook/useOutClick';

const items = [
	{
		name: 'Test 1',
		value: 'test1',
		subitems: [
			{ name: 'Subtest 1', value: 'subtest1' },
			{ name: 'Subtest 2', value: 'subtest2' },
		],
	},
	{
		name: 'Test 2',
		value: 'test2',
		subitems: [
			{ name: 'Subtest 3', value: 'subtest3' },
			{ name: 'Subtest 4', value: 'subtest4' },
		],
	},
	{
		name: 'Test 3',
		value: 'test3',
		subitems: [
			{ name: 'Subtest 5', value: 'subtest5' },
			{ name: 'Subtest 6', value: 'subtest6' },
		],
	},
];

const DrD = ({ item }) => {
	const [isOpen, setIsOpen] = useState(false);

	const ref = useOutClick((_event) => {
		if (isOpen) {
			console.log('You clicked outside of me!');
			setIsOpen(false);
		}
	});

	return (
		<div className="dd-item" ref={ref}>
			<div className="dd-item-name" onClick={() => setIsOpen(!isOpen)}>
				{item.name}
			</div>
			{item.subitems && item.subitems.length > 0 && isOpen ? (
				<ul className="dd-subitems">
					{item.subitems.map((subitem) => (
						<li className="dd-subitem" key={subitem.value}>
							{subitem.name}
						</li>
					))}
				</ul>
			) : null}
		</div>
	);
};

DrD.propTypes = {
	item: PropTypes.shape({
		name: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
		subitems: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string.isRequired,
				value: PropTypes.string.isRequired,
			})
		),
	}).isRequired,
};

const TestPage = () => {
	return (
		<Layout layout={LayoutTemplates.default} title="Test Page">
			<div className="centered-block">
				<div className="text">
					<strong>Test page</strong>
				</div>
				<ul>
					{items.map((item) => (
						<li className="dd-item" key={item.value}>
							<DrD item={item} />
						</li>
					))}
				</ul>
				<button className="test-button" type="button" onClick={() => console.log('Button clicked!')}>
					Toggle
				</button>
			</div>
		</Layout>
	);
};

export default TestPage;
